/**
 * Asset origin. Local development and same-origin deployments serve assets from /assets
 * (public/assets). Production can point VITE_ASSET_ORIGIN at an R2 public bucket or custom
 * domain (e.g. https://assets.example.com) holding the same relative paths.
 */
const configured = (import.meta.env.VITE_ASSET_ORIGIN as string | undefined)?.trim();
export const ASSET_ORIGIN = (configured && configured.length > 0 ? configured : `${import.meta.env.BASE_URL}assets`).replace(/\/+$/, '');

export function assetUrl(path: string): string {
  if (/^https:\/\//.test(path)) return path;
  return `${ASSET_ORIGIN}/${path.replace(/^\/+/, '')}`;
}

/** True when assets are served cross-origin (media must then request CORS). */
export const ASSETS_CROSS_ORIGIN = typeof location !== 'undefined' && !ASSET_ORIGIN.startsWith('/') && !ASSET_ORIGIN.startsWith(location.origin);
